<template>
  <v-content class="grey lighten-3 pt-3">
    <div id="core-view">
      <!-- <v-fade-transition mode="out-in"> -->
      <router-view />
      <!-- </v-fade-transition> -->
    </div>
  </v-content>
</template>

<script>
import i18n from "@/app/plugins/i18n";

export default {
  name: "CoreView",

  metaInfo() {
    return {
      title: i18n.t("Common.title")
    };
  }
};
</script>
